import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const rootElement = document.getElementById('root');
const baseUrl: string | undefined = document.getElementsByTagName('base')[0].getAttribute('href') || undefined;

ReactDOM.render(
    <BrowserRouter basename={baseUrl} >
        <App />
    </BrowserRouter>,
    rootElement);

registerServiceWorker();

